<script lang="ts">
import { watch } from "vue";
import useNumber from "@/composable/components/number";
import useEmptyNumberJumpClamp from "@/composable/components/useEmptyNumberJumpClamp";
import { BNumberinput } from "buefy";

export default {
  name: "InputNumber",
  components: { BNumberinput },
  props: {
    inputType: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      required: true,
    },
    from: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    isSimpleValue: Boolean,
  },
  emits: ["update:numberValue"],
  setup(props, ctx) {
    const { refNumber: valueNumber } = useNumber();
    watch(
      () => props.from,
      (value) => {
        valueNumber.value = value;
      },
      { immediate: true },
    );
    useEmptyNumberJumpClamp(valueNumber, () => props.min, () => props.max);
    function updateValueNumber() {
      ctx.emit("update:numberValue", {
        value: valueNumber.value,
        filter: valueNumber.value,
        isSimpleValue: props.isSimpleValue,
      });
    }
    return {
      valueNumber,
      updateValueNumber,
    };
  },
};
</script>

<template>
  <b-numberinput
    v-model="valueNumber"
    :max="max"
    :min="min"
    :placeholder="format"
    :aria-label="format"
    controls-position="compact"
    controls-rounded
    :step="format === 'float' ? 0.001 : 1"
    type="is-primary is-light"
    @blur="updateValueNumber"
    @input="updateValueNumber"
  />
</template>
